export const topDashMenu=[
    {label:"Countries",key:1},
    {label:"Companies",key:2},
    {label:"Predefined dates",key:3},
    {label:"Custom date",key:4}
]